import { DSModal } from "@components/design-system/organisms";

// Local fallback only: the server always supplies a non-empty
// recordingConsentHeader whenever consent is required, so this is used only
// against older backends (or cache entries written before the field existed).
export const DEFAULT_CONSENT_HEADER = "Client Recording Consent";

export const RecordingConsentModal = ({
  isOpen,
  onAcknowledge,
  onCancel,
  consentHeader,
  consentText,
  loading = false,
}) => {
  return (
    <DSModal
      isOpen={isOpen}
      onClose={() => {}}
      title={consentHeader || DEFAULT_CONSENT_HEADER}
      dismissible={false}
      disableBackdropClose
      dataTestId="recording-consent-modal"
      actions={[
        {
          label: "YES — I have obtained consent",
          variant: "primary",
          onClick: onAcknowledge,
          disabled: loading,
          dataTestId: "recording-consent-acknowledge",
        },
        {
          label: "Cancel",
          variant: "cancel",
          onClick: onCancel,
          disabled: loading,
          dataTestId: "recording-consent-cancel",
        },
      ]}
    >
      <p className="whitespace-pre-line">{consentText}</p>
    </DSModal>
  );
};
